webpackJsonp([67419765367735],{

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PatternConstruction = __webpack_require__(22);
	
	var _PatternConstruction2 = _interopRequireDefault(_PatternConstruction);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(99);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _PatternConstruction2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Clone the Starter App'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll checkout the starter project and get it running.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We\'ll be using a starter project so that we can focus on creating and refactoring the dialogs, and see them in a realistic context.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Clone the Project'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To explain how the forms work, we\'re going to check out a project from GitHub that we\'ll build the forms into. The code we\'ll need is in a repository on GitHub under ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore-forms-pattern-tutorial' },
	        'lore/lore-forms-pattern-tutorial'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Run this command to clone the server into your local environment:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { title: 'SSH', active: true, text: '\n        $ git clone git@github.com:lore/lore-forms-pattern-tutorial.git\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { title: 'HTTPS', text: '\n        $ git clone https://github.com/lore/lore-forms-pattern-tutorial.git\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Install Dependencies'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once the repo is cloned, navigate into the directory and install the dependencies:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      $ cd lore-forms-pattern-tutorial\n      $ npm install\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Start the Webpack Development Server'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With the dependencies are installed, run the application by typing ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'npm start'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      $ npm start\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'A successful execution will produce output similar to this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      webpack-dev-server --hot --env.webpack=development --env.lore=development\n\n      build [==                  ] 10%\n      Project is running at http://localhost:3000/\n\n      webpack output is served from /\n      404s will fallback to /index.html\n\n      Build completed in 6.541s\n\n      Hash: 199de1b7032b223700a9\n      Version: webpack 3.12.0\n      Time: 6712ms\n\n                       Asset   Size       Chunks                    Chunk Names\n        favicons/favicon.ico   33.3 kB            [emitted]\n       favicon-manifest.json   613 bytes          [emitted]\n      assets/images/logo.png   27.7 kB            [emitted]\n              bundle.main.js   3.16 MB         0  [emitted]  [big]  main\n            bundle.vendor.js   1.27 MB         1  [emitted]  [big]  vendor\n                  index.html   4.41 kB            [emitted]\n\n      ...\n\n      webpack: Compiled successfully.\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This step invokes ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://webpack.github.io/' },
	        'Webpack'
	      ),
	      ' to build the application and starts a development server so you can view it in the browser. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'But don\'t view it just yet'
	      ),
	      ' - the application won\'t work until we start the mock API server.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-2/' },
	        'start the mock API server'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-forms-pattern-setup-step-1-js-942dda3ca8de98e0b2a0.js